import { Header } from "apps/diagnostics/externalDiagnostics/Header/header";
import { useStyles } from "./externalLayout.styles";
import { IExternalLayoutProps } from "./externalLayout.types";

export const ExternalLayout = (props: IExternalLayoutProps) => {
  const styles = useStyles();
  return (
    <div className={styles.mainWrapper}>
      {!props.hideHeader && (
        <Header
          style={props.style}
          popoverLinkWrappers={[]}
          headerColor={props.headerColor}
          headerLogoUrl={props.headerLogoUrl}
          hideHelp={props.hideHelp}
        />
      )}
      <div className={styles.contentWrapper}>{props.children}</div>
    </div>
  );
};
